import { Outlet, createFileRoute } from "@tanstack/react-router";

// Pure pass-through: TanStack Router's dot-notation nesting makes "onboarding.index.tsx" and
// "onboarding.store.tsx" children of this route. Both only redirect now (to /join and /sell).
export const Route = createFileRoute("/_onboarding/onboarding")({
  component: () => <Outlet />,
});
